import api from './api';

export interface Colaborador {
    id: number;
    nome: string;
    cpf: string;
    rg: string;
    dataNascimento: string;
    cargo: string;
    dataAdmissao: string | null;
    banco: string;
    agencia: string;
    pix?:string;
    conta: string;
    endereco: {
        cep: string;
        endereco: string;
        numero: string;
        complemento?: string;
        bairro: string;
        cidade: string;
        estado: string;
    };
   
}

export interface CreateColaboradorDTO {
    nome: string;
    nomeUsuario: string;
    cpf: string;
    rg: string;
    dataNascimento: string | null;
    cargo: string;
    dataAdmissao: string | null;
    banco: string;
    agencia: string;
    conta: string;
    email: string;
    senha: string;
    telefone: string;
    cep: string;
    endereco: string;
    numero: string;
    complemento?: string;
    bairro: string;
    cidade: string;
    estado: string;
    isAdmin:boolean;
    cargoIds: number[];
    permissaoIds: number[];
    pix?:string

    
}

export const colaboradorService = {
    listar: async (): Promise<Colaborador[]> => {
        const response = await api.get('/colaboradores');
        return response.data.map((colab: any) => ({
            ...colab,
            usuario: {
                ...colab.usuario,
            }
        }));
    },

    buscarPorCpf: async (cpf: string): Promise<Colaborador> => {
        const response = await api.get(`/colaboradores/cpf/${cpf}`);
        const colab = response.data;
        return {
            ...colab,
           
        };
    },

    buscarPorId: async (id: number): Promise<Colaborador> => {
        const response = await api.get(`/colaboradores/${id}`);
        const colab = response.data;
        return {
            ...colab,
           
        };
    },

    criar: async (data: CreateColaboradorDTO): Promise<Colaborador> => {
        const response = await api.post('/colaboradores', data);
        const colab = response.data;
        return {
            ...colab,
            
        };
    },

    atualizar: async (id: number, data: Partial<CreateColaboradorDTO>): Promise<Colaborador> => {
        console.log("-----------------Dados para atualizar")
        console.log(data)
        const response = await api.put(`/colaboradores/${id}`, data);
        const colab = response.data;
        return {
            ...colab,
            
        };
    },

    excluir: async (id: number): Promise<void> => {
        await api.delete(`/colaboradores/${id}`);
    }
}; 